export const BASE_ADJUSTMENTS_BAR_INITIAL_Y_AXIS_POSITION = -428;
export const BASE_ADJUSTMENTS_BAR_PADDING_TOP = 96;
